import React, { useState } from 'react'
import controls from './controls';
import Backdrop from '@mui/material/Backdrop';
import { CircularProgress, Paper, Typography } from '@mui/material';

const Loading = () => {
    const [[showLoading, loadingText], setShowLoading] = useState([true, ""]);
    // showLoading && controls.setView !== null && controls.setView("");
    controls.setLoading = setShowLoading;
    // console.log(loadingText);

  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: "rgba(8, 16, 14, 0.46)",
      }}
      open={showLoading}
      onClick={()=>{setShowLoading([false, ""])}}
      aria-live="polite"
    >
      <Paper
        sx={{
          px: 3,
          py: 2,
          minWidth: 220,
          border: "1px solid",
          borderColor: "divider",
          bgcolor: "background.paper",
          textAlign: "center",
        }}
      >
        <CircularProgress color="primary" size={26} />
        <Typography sx={{ mt: 1.1, color: "text.primary", fontWeight: 600 }}>
          {(loadingText || "Please wait...").trim()}
        </Typography>
      </Paper>
    </Backdrop>
  )
}

export default Loading

// export {setLoading};
